import { normalizeSneakyText, normalizeText } from 'utils/text';
import { Client } from 'entities';

type ValidationProperties = { name: string; ticket: string; client: string };

type ValidationParams<Entity extends ValidationProperties = ValidationProperties> = {
  project: Entity;
  clients: Client[];
};

const validations = {
  clientName: {
    validator: (name: string, { project, clients }: ValidationParams): boolean => {
      const clientName = clients.find(({ id }) => id === project.client)?.name.toLowerCase();

      const hasClientOnName = clientName && name.includes(clientName);

      return !!hasClientOnName;
    },

    errorKey: 'project-name-cannot-contain-client-name',
  },

  ticket: {
    validator: (name: string, { project }: ValidationParams): boolean => {
      const hasTicketOnName = [
        name.includes(project.ticket),
        project.name.includes(project.ticket),
      ].some(Boolean);

      return hasTicketOnName;
    },

    errorKey: 'project-name-cannot-contain-ticket-number',
  },

  offerwise: {
    validator: (name: string): boolean => {
      const withoutSpecialChars = name.replace(/[^a-zA-Z]/g, ' ');

      return (
        [' ow ', 'offerwise'].some((offerwise) => withoutSpecialChars.includes(offerwise)) ||
        name.split(' ').includes('ow')
      );
    },

    errorKey: 'project-name-cannot-contain-offerwise',
  },

  size: {
    validator: (name: string): boolean => {
      return name.length > 100;
    },

    errorKey: 'project-name-cannot-be-this-big',
  },
};

export function validateProjectName(params: ValidationParams): string | void {
  const name = normalizeSneakyText(params.project.name);

  const error = Object.values(validations).find(({ validator }) => validator(name, params));

  return error?.errorKey;
}

export function validateProjectNameLooksLikeEmailSubject(projectName: string): boolean {
  const name = normalizeText(projectName);

  const hasWeirdChards = /[!@#$%¨&*()[\]{}`'"^~;.,:/?\\|+=-_]/.test(name);
  const long = name.length >= 65;
  const longWord = name.split(' ').find((piece) => piece.length > 20);

  return [hasWeirdChards, long, longWord].some(Boolean);
}
